webpackJsonp([14],{

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_authCommon__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_authCommon__["a" /* default */]],
    data: function data() {
        return {
            full: false
        };
    },

    methods: {},
    mounted: function mounted() {
        var _this = this;

        if (this.popupFestival) {
            this.popupBreath();

            var img = new Image();
            img.onload = function () {
                if (window.innerHeight < img.height || window.innerWidth < img.width) {
                    _this.full = true;
                } else {
                    _this.full = false;
                }
            };

            img.src = this.popupFestival.festival_popup.img;
        }
    }
});

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      popupFestival: window._popupFestival,
      inputLength: window._inputLength
    };
  },

  methods: {
    popupBreath: function popupBreath() {
      var VUE = this;
      if (this.popupFestival.festival_popup.flag == true) {
        $('.fadein').fadeIn();
        setTimeout(function () {
          VUE.closePopup();
        }, 5000);
      }
    },
    closePopup: function closePopup() {
      $('.fadein').fadeOut();
    }
  }
});

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popup_festival_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82797d42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popup_festival_vue__ = __webpack_require__(19);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popup_festival_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82797d42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popup_festival_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.popupFestival)?_c('div',[_c('div',{staticClass:"fadein"},[_c('div',{staticClass:"popup-image",class:(_vm.full) ? 'full' : ''},[_c('div',{staticClass:"guide-close-button floating-right"},[_c('i',{staticClass:"fa fa-times-circle fa-2x",on:{"click":_vm.closePopup}})]),_vm._v(" "),_c('div',{staticClass:"message"}),_vm._v(" "),_c('img',{staticStyle:{"cursor":"pointer","height":"100%"},attrs:{"src":_vm.popupFestival.festival_popup.img,"id":"fadein1-img"}})])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_popup_festival__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_authCommon__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_authCommon__["a" /* default */]],
  components: {
    popupFestival: __WEBPACK_IMPORTED_MODULE_0__components_popup_festival__["a" /* default */]
  },
  data: function data() {
    return {
      selectedLang: null,
      langSelect: lang_select,
      cookielang: _cookie,
      companycode: window.compcode,
      currentTemplate: window._currentTemplate,
      customTemplate: window._customTemplate,
      langList: window.langList,
      domain_name: window.domain_name,
      formData: {
        accname: "",
        pass: ""
      },
      error: {
        loginIdReq: false,
        message: ""
      },
      token: window.token,
      showLogo: window.showLogo
    };
  },

  computed: {},
  methods: {
    isMobile: function isMobile() {
      if (window._isMobile == '1') {
        return true;
      }
      return false;
    },
    mobile: function mobile() {
      var redirect = window._baseUrl.replace(window._webTemplate, window._mobileTemplate) + '/login?desktop=0';
      window.location.href = redirect;
    },
    logoSwitch: function logoSwitch() {
      if (this.cookielang == 'en_US') {
        return 'assets/images/eng_3sing.png';
      }
      return 'assets/images/3sing.png';
    },

    changeLanguage: function changeLanguage(value) {
      this.$ajax({
        url: "",
        type: "get",
        data: {
          language: value
        }
      }).then(function (response) {
        window.location.reload();
      });
    },
    login: function login() {
      var _this = this;

      if (this.formData.accname == "") {
        this.error.loginIdReq = true;
        this.error.message = this.lang.emptyLoginId;
        alert(this.error.message);
      } else if (this.formData.pass == "") {
        this.error.loginIdReq = true;
        this.error.message = this.lang.emptyPassword;
        alert(this.error.message);
      } else {
        this.error.loginIdReq = false;
        this.formData.token = token.arr_9 + '|' + this.formData.accname;
        this.$ajax({
          method: "post",
          url: "",
          data: this.formData
        }).catch(function (error) {
          _this.error.loginIdReq = true;
          _this.error.message = error.responseJSON.message;
          alert(_this.error.message);
        });
      }
    }
  },
  mounted: function mounted() {
    this.selectedLang = _.findKey(this.langSelect, {
      language_code: this.cookielang
    });
    $('#username').focus();
  }
});

/***/ }),

/***/ 900:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_apps_auth_wkl_vue__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);




new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#login',
  template: '<Login ></Login>',
  components: { Login: __WEBPACK_IMPORTED_MODULE_0__vue_apps_auth_wkl_vue__["a" /* default */] }
});

/***/ }),

/***/ 901:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wkl_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6356dd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wkl_vue__ = __webpack_require__(903);
function injectStyle (ssrContext) {
  __webpack_require__(902)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wkl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6356dd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wkl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 902:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 903:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('popupFestival'),_vm._v(" "),_c('div',{attrs:{"id":"wrap"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-left"},[_c('div',{staticClass:"login-detail"},[_c('form',{staticClass:"basic-grey",attrs:{"action":"","method":"post","name":"myForm","target":"_self","autocomplete":"off"}},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLang),expression:"selectedLang"}],attrs:{"name":"language"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLang=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.changeLanguage(_vm.selectedLang)}]}},[_c('option',{attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.langSelect[1].caption))]),_vm._v(" "),_c('option',{attrs:{"value":"2","selected":""}},[_vm._v(_vm._s(_vm.langSelect[2].caption)+"中文")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v(_vm._s(_vm.langSelect[3].caption)+"中文")])])]),_vm._v(" "),_c('label',[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.langList.login['LOGIN.LBL_LOGIN'])+" :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.accname),expression:"formData.accname"}],attrs:{"type":"text","name":"fr_username","id":"username","size":"13","maxlength":_vm.inputLength.username,"placeholder":"Username"},domProps:{"value":(_vm.formData.accname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "accname", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.langList.login['LOGIN.PASSWORD'])+" :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.pass),expression:"formData.pass"}],attrs:{"type":"password","id":"password","name":"fr_password","maxlength":_vm.inputLength.password,"placeholder":"Password"},domProps:{"value":(_vm.formData.pass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "pass", $event.target.value)}}})]),_vm._v(" "),_c('label',{staticStyle:{"margin-left":"80px"}},[_c('input',{staticClass:"button",attrs:{"name":"fr_submit","type":"submit"},domProps:{"value":_vm.langList.login['LOGIN.BTN_LOGIN']},on:{"click":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}}),_vm._v(" "),(_vm.isMobile())?_c('div',{staticClass:"mob-btn"},[_c('span',{on:{"click":function($event){return _vm.mobile()}}},[_c('i',{staticClass:"fa fa-mobile",attrs:{"aria-hidden":"true"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"login-right"})]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',{staticClass:"footer-con"},[_c('div',{staticClass:"footer1"}),_vm._v(" "),_c('div',{staticClass:"footer2"},[_c('span',{attrs:{"id":"footer"}},[_vm._v("© "+_vm._s(_vm.domain_name))]),_c('br'),_vm._v(" "),(_vm.showLogo)?_c('table',{staticStyle:{"border":"1px","margin":"0 auto"},attrs:{"border":"0","cellpadding":"0","cellspacing":"0"}},[_c('tr',[_vm._m(0),_vm._v(" "),_c('td',{attrs:{"width":"4"}}),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"border":"0px"},attrs:{"src":_vm.logoSwitch()}})])])]):_vm._e()])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"id":"footer"}},[_c('table',{staticStyle:{"margin-left":"15px"},attrs:{"border":"0","cellpadding":"0","cellspacing":"0"}},[_c('tr',[_c('td',[_vm._v("\n                              Powered by\n                            ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[900]);


// WEBPACK FOOTER //
// js/auth/wkl.06290794aa94640159c0.js